
export const diffDays = (date) => {
    const endDate = new Date(date);
    const currentDate = new Date();
    const diffInMs = endDate - currentDate;
    return Math.round(diffInMs / (1000 * 60 * 60 * 24))
}


